import { z } from 'zod'

export const TimeZoneContextSchema = z.object({
  timeZone: z.string(),
  weekday: z.string(),
  month: z.string(),
  day: z.string(),
  year: z.string(),
  hour: z.string(),
  minute: z.string(),
  hour12: z.boolean(),
})

export const PostTimelineSchema = z.object({
  withinTheYear: z.boolean(),
  short: z.string(),
  long: z.string(),
  time: z.string(),
})

export type TimeZoneContextTypes = z.infer<typeof TimeZoneContextSchema>
export type PostTimelineTypes = z.infer<typeof PostTimelineSchema>
